var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('portal-target',{attrs:{"name":"modal"}}),_c('router-view',{on:{"open-leaderboard":_vm.openLeaderboard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }